import React from "react";
import { UrlProvider } from "../../../../../../api/UrlProvider";
import withTranslations from "../../../../../../hocs/withTranslations";
import SquaberTooltip from "../../../SquaberTooltip/";
import { getTranslatedMarket } from "../../../../../../lib/getTranslatedMarket";
import { AdapterSquaberLink } from "../../../SquaberLink/modules/default";

const TickerAsLink = ({
  resultMetaData: { ticker, market, company_name },
  locale,
  marketTranslations
}) => {
  const translatedMarket = getTranslatedMarket(
    locale,
    market,
    marketTranslations
  );
  let content = (
    <AdapterSquaberLink
      to={UrlProvider.getUrl("fe.stockPage", {
        locale,
        marketId: translatedMarket,
        stockId: ticker
      })}
    >
      {ticker}
    </AdapterSquaberLink>
  );

  if (company_name) {
    content = <SquaberTooltip title={company_name}>{content}</SquaberTooltip>;
  }

  return <div className="ticker-as-link">{content}</div>;
};

const shouldRenderDash = props => {
  const ticker = props?.resultMetaData?.ticker;

  return ticker === null || typeof ticker === "undefined";
};

TickerAsLink.shouldRenderDash = shouldRenderDash;

const TickerAsLinkWithTranslations = withTranslations(TickerAsLink);
TickerAsLinkWithTranslations.shouldRenderDash = shouldRenderDash;

export default TickerAsLinkWithTranslations;
